import { render } from "./B2CAnalyzer.vue?vue&type=template&id=3ff8c888&lang=pug"
import script from "./B2CAnalyzer.vue?vue&type=script&setup=true&lang=js"
export * from "./B2CAnalyzer.vue?vue&type=script&setup=true&lang=js"

import "./B2CAnalyzer.vue?vue&type=style&index=0&id=3ff8c888&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__